var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2549 14.9145L18.5172 13.0295C18.5979 12.4495 18.6717 11.9193 18.7373 11.4329C18.8721 10.4334 18.9395 9.93367 18.6406 9.59184C18.3418 9.25 17.8282 9.25 16.801 9.25H7.19904C6.17182 9.25 5.65821 9.25 5.35938 9.59184C5.06054 9.93367 5.12793 10.4334 5.26272 11.4329C5.32833 11.9195 5.40207 12.4493 5.48281 13.0295L5.74515 14.9145C6.03026 16.9632 6.17282 17.9876 6.47509 18.8103C7.04034 20.3488 8.01743 21.4947 9.18366 21.9868C9.8073 22.25 10.5382 22.25 12 22.25C13.4618 22.25 14.1927 22.25 14.8164 21.9868C15.9826 21.4947 16.9597 20.3488 17.5249 18.8103C17.8272 17.9876 17.9698 16.9632 18.2549 14.9145Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C9.37665 1.5 7.25 3.62665 7.25 6.25V6.5H4C3.58579 6.5 3.25 6.83579 3.25 7.25C3.25 7.66421 3.58579 8 4 8H20C20.4142 8 20.75 7.66421 20.75 7.25C20.75 6.83579 20.4142 6.5 20 6.5H16.75V6.25C16.75 3.62665 14.6234 1.5 12 1.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 11.25C10.75 10.8358 10.4142 10.5 10 10.5C9.58579 10.5 9.25 10.8358 9.25 11.25V19.25C9.25 19.6642 9.58579 20 10 20C10.4142 20 10.75 19.6642 10.75 19.25V11.25ZM14.75 11.25C14.75 10.8358 14.4142 10.5 14 10.5C13.5858 10.5 13.25 10.8358 13.25 11.25V19.25C13.25 19.6642 13.5858 20 14 20C14.4142 20 14.75 19.6642 14.75 19.25V11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.5fd31b26e8461741ea1cb7db25b3bfd5.svg";
export { ForwardRef as ReactComponent };